import React, { Component } from 'react'
import { Link } from 'react-router'
import {Col, Modal} from 'react-bootstrap'
import FormContact from '../../features/commons/ContactForm/ContactForm.container'
import Button from '../Buttons'
import { translate } from "react-translate"

@translate("Broker")
export default class Broker extends Component {

	constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  changeViewModal() {
    this.setState({showModal: !this.state.showModal })
  }

  render () {

  	const { item, t, infoout } = this.props;

    let info = (
      <div className="broker-info">
        <Button classes="btn-contact" text={t("Contactar")} clickButton={() => this.changeViewModal()} />
      </div>
    )

    return (
    	<div>
	    	<div className="broker-container">
	        <div className="broker-img">
            <div className="large" style={{backgroundImage: 'url('+((item.image) ? item.image : item.image_home_fullsize)+')'}}></div>
            { !infoout ? info : '' }
	        </div>
          <div className="title-broker">{item.name}</div>
          <div className="subtitle-broker">{item.position}</div>
          { infoout ? info : '' }
	    	</div>
	  		<Modal
            className="modal-contact-form"
            show={this.state.showModal}
            onHide={(e) => this.changeViewModal(e)}
            aria-labelledby="contained-modal-title"
            bsSize="large"
          >
          <Modal.Body>
            <div className="form-box">
              <div className="form-content form-slider">
				        <Col md={12} sm={12} className="inputs-form form-modal hidden-xs">
				          <FormContact broker={item} textareaDefault={false} />
				        </Col>
				        <div className="col-md-12 inputs-form visible-xs">
				          <FormContact broker={item} textareaDefault={false} />
				        </div>
              </div>
              <div className="box-close">
                <Button type="submit" clickButton={() => this.changeViewModal()} className="btn-close">
                  <i className="fa fa-times fa-lg"></i>
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
  		</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Brokers/item.js